import React from 'react';

export default function TermsAndConditionsDE() {
  return (
    <div>
      {/* <h1> */}
      {/*   <strong>Allgemeine Geschäftsbedingungen (AGB)</strong> */}
      {/* </h1> */}
      <p>
        Der Online-Shop
        <a target="_blank" rel="noopener noreferrer" href="http://www.self.co/">
          &nbsp;
          <strong>
            <u>www.self.co</u>
          </strong>
        </a>{' '}
        wird betrieben von&nbsp;<strong>UAB Imunodiagnostika</strong>, eingetragene Adresse: Molėtų g. 16, Didžioji
        Riešė, Bezirk Vilnius, Litauen.
        <br />
        &nbsp;Unternehmenscode: 303064228
        <br />
        &nbsp;USt.-ID: LT100008020911
        <br />
        &nbsp;Telefon: +370 685 98360
      </p>
      <h2>
        <strong>1. Allgemeine Bestimmungen</strong>
      </h2>
      <h3>
        <strong>Begriffsbestimmungen</strong>
      </h3>
      <ul>
        <li>
          <strong>AGB</strong> – Diese Allgemeinen Geschäftsbedingungen für den Online-Shop
          <a target="_blank" rel="noopener noreferrer" href="http://www.self.co/">
            &nbsp;
            <strong>
              <u>www.self.co</u>
            </strong>
          </a>
          .
        </li>
        <li>
          <strong>Imunodiagnostika</strong> – UAB Imunodiagnostika, Molėtų g. 16, Didžioji Riešė, Bezirk Vilnius,
          Litauen.
        </li>
        <li>
          <strong>Vertrag</strong> – Die Vereinbarung oder Auftragsbestätigung, die den Kauf von Dienstleistungen über
          den Online-Shop bestätigt, einschließlich aller beigefügten Dokumente.
        </li>
        <li>
          <strong>Bestellung</strong> – Die vom Kunden bestellte Dienstleistung oder das Produkt, erstellt auf Grundlage
          der vom Kunden oder Empfänger bereitgestellten Daten.
        </li>
        <li>
          <strong>Kunde</strong> – Die Person, die im Vertrag als Vertragspartei genannt wird und diese AGB akzeptiert.
        </li>
        <li>
          <strong>Empfänger</strong> – Die Person, die die vom Kunden gekauften Dienstleistungen nutzen kann.
        </li>
        <li>
          <strong>Shop</strong> – Der in diesen AGB erwähnte Online-Shop.
        </li>
        <li>
          <strong>Produkt / Dienstleistung</strong> – Alle im Shop angebotenen Waren oder Dienstleistungen.
        </li>
        <li>
          <strong>Vertragsdatum</strong> – Das Datum, an dem Imunodiagnostika die Dienstleistung aktiviert und der Kunde
          eine Auftragsbestätigung erhält.
        </li>
        <li>
          <strong>Klinik</strong> – Ein Partner von Imunodiagnostika, der die Probenentnahme beim Kunden durchführt.
        </li>
      </ul>
      <p>
        Diese AGB haben Vorrang vor allen anderen Dokumenten, die der Kunde im Zusammenhang mit dem Betrieb des Shops
        erhält.
        <br />
        &nbsp;Mit der Bestellung bestätigt der Kunde, dass er diese AGB gelesen, verstanden und vollständig akzeptiert
        hat.
      </p>
      <p>
        Jede volljährige und geschäftsfähige Person kann Kunde werden.
        <br />
        &nbsp;Der Vertrag wird gemäß dem Recht der Republik Litauen und in litauischer Sprache abgeschlossen.
        <br />
        &nbsp;Diese AGB sind Bestandteil des Dienstleistungsvertrags und regeln die Verkaufs- und Nutzungsbedingungen.
        <br />
        &nbsp;Mit der Annahme der AGB erklärt sich der Kunde auch mit der elektronischen Kommunikation zur
        Vertragsabwicklung einverstanden.
      </p>
      <p>Imunodiagnostika ist für die Qualität der erbrachten Dienstleistungen verantwortlich.</p>

      <h2>
        <strong>2. Verarbeitung und Sicherheit personenbezogener Daten</strong>
      </h2>
      <p>
        Mit der Bestellung stimmen Sie zu, dass Imunodiagnostika für die Verarbeitung Ihrer personenbezogenen Daten
        verantwortlich ist und diese für folgende Zwecke nutzen darf:
      </p>
      <ul>
        <li>Abschluss und Durchführung des Vertrags</li>
        <li>Informationen über neue Dienstleistungen, Produkte und Aktionen</li>
        <li>Archivierungs- und Statistikzwecke</li>
      </ul>
      <p>
        Sie können der Zusendung von Werbeinformationen jederzeit widersprechen, indem Sie eine E-Mail an&nbsp;
        <strong>hello@self.co</strong> senden.
        <br />
        &nbsp;Sie haben auch das Recht, die Löschung Ihrer Daten zu verlangen, sofern dies nicht gegen gesetzliche
        Anforderungen verstößt. Die Angabe Ihrer Daten erfolgt freiwillig.
      </p>
      <p>
        Gemäß dem litauischen Datenschutzgesetz (Artikel 13 und 14) dürfen Ihre personenbezogenen Daten – Name,
        Nachname, Geschlecht, Geburtsdatum, E-Mail-Adresse, Telefonnummer und Wohnadresse – an Imunodiagnostika und die
        Klinik weitergegeben werden.
      </p>

      <h2>
        <strong>3. Bestellungen und Auftragsbestätigungen</strong>
      </h2>
      <p>
        Bestellungen können rund um die Uhr auf
        <a target="_blank" rel="noopener noreferrer" href="http://www.self.co/">
          &nbsp;
          <strong>
            <u>www.self.co</u>
          </strong>
        </a>{' '}
        aufgegeben werden, außer während technischer Wartungszeiten.
      </p>
      <p>
        Eine Bestellung ist nur gültig, wenn der Kunde den Dienst korrekt konfiguriert und vollständig online bezahlt
        hat.
      </p>
      <p>
        Der Kunde muss korrekte und vollständige Daten angeben, damit die Bestellung ordnungsgemäß bearbeitet werden
        kann. Bestellungen mit fehlerhaften Daten können manuell überprüft und ggf. storniert werden. In diesem Fall
        wird der Kunde innerhalb von 3 Werktagen per Telefon oder E-Mail benachrichtigt.
      </p>
      <p>
        Imunodiagnostika bestätigt Bestellungen innerhalb von 24 Stunden nach Zahlungseingang per Telefon oder E-Mail
        und informiert die Klinik über den Termin zur Probenentnahme. Fällt der Zeitraum auf Wochenenden oder Feiertage,
        kann sich die Bestätigung verzögern.
      </p>
      <p>
        Eine Bestellung wird&nbsp;<strong>nicht</strong> bearbeitet, wenn:
      </p>
      <ul>
        <li>Falsche oder unvollständige Daten angegeben wurden</li>
        <li>Der Kunde nicht unter den angegebenen Kontaktdaten erreichbar ist</li>
        <li>Die Bestellung fehlerhaft übermittelt wurde</li>
        <li>
          Imunodiagnostika den Verdacht hat, dass die Bestellung gegen geltendes Recht verstößt oder unbefugt aufgegeben
          wurde (z. B. Identitätsdiebstahl oder Missbrauch von Kontodaten)
        </li>
      </ul>
      <p>
        Der Kunde muss die gekauften Dienstleistungen innerhalb von&nbsp;<strong>30 Tagen</strong> nach Zahlung nutzen.
        Erfolgt innerhalb dieser Frist keine Probenabgabe in der Klinik, gilt die Dienstleistung als vollständig
        erbracht.
      </p>
      <p>
        Die übliche Bearbeitungszeit für Dienstleistungen beträgt&nbsp;<strong>7 Werktage</strong> ab dem Tag der
        Probenentnahme.
      </p>

      <h2>
        <strong>4. Zahlungen</strong>
      </h2>
      <p>
        Der Gesamtpreis der Bestellung wird im dritten Schritt des Bestellprozesses angezeigt. Dieser Preis ist der
        Endpreis und enthält alle Steuern und Gebühren.
      </p>
      <p>
        Zahlungen erfolgen ausschließlich online über
        <a target="_blank" rel="noopener noreferrer" href="http://www.self.co/">
          &nbsp;
          <strong>
            <u>www.self.co</u>
          </strong>
        </a>{' '}
        mit dem Zahlungssystem&nbsp;<strong>Mollie</strong>.<br />
        &nbsp;Alle Preise sind in Euro angegeben und enthalten die Mehrwertsteuer.
        <br />
        &nbsp;Es fallen keine zusätzlichen Gebühren an, außer den Gebühren Ihrer Bank.
      </p>

      <h2>
        <strong>5. Vertragskündigung</strong>
      </h2>
      <p>
        Vor Beginn der Dienstleistung (d. h. vor der Probenentnahme) kann der Kunde den Vertrag kündigen, indem er eine
        E-Mail an&nbsp;<strong>hello@self.co</strong> sendet.
      </p>
      <p>
        Imunodiagnostika erstattet den gezahlten Betrag innerhalb von&nbsp;<strong>14 Tagen</strong> auf das Konto
        zurück, von dem die Zahlung erfolgte. Es entstehen keine zusätzlichen Kosten.
      </p>
      <p>
        Nach Beginn der Dienstleistung (nach der Probenentnahme) ist eine Vertragskündigung nicht mehr möglich. In
        diesem Fall gilt die Dienstleistung als vollständig erbracht.
      </p>

      <h2>
        <strong>6. Kontakt und Beschwerden</strong>
      </h2>
      <p>Kunden können Fragen, Vorschläge oder Probleme im Zusammenhang mit dem Shop auf folgende Weise melden:</p>
      <ul>
        <li>
          Per E-Mail:&nbsp;<strong>hello@self.co</strong>
        </li>
        <li>Telefonisch: +370 640 65680 (Mo–Fr, 9:00–18:00)</li>
      </ul>
      <p>
        Beschwerden müssen&nbsp;<strong>schriftlich</strong> eingereicht werden.
      </p>
      <ul>
        <li>
          Servicebezogene Beschwerden werden innerhalb von&nbsp;<strong>10 Werktagen</strong> bearbeitet.
        </li>
        <li>
          Medizinische Beschwerden werden innerhalb von&nbsp;<strong>30 Werktagen</strong> bearbeitet, sobald alle
          erforderlichen Informationen vorliegen.
        </li>
      </ul>
      <p>
        Postadresse für Beschwerden: Molėtų g. 16, Didžioji Riešė, Bezirk Vilnius, oder per E-Mail an&nbsp;
        <strong>hello@self.co</strong>.
      </p>
      <p>Telefonanrufe werden gemäß dem Tarifplan des Kunden berechnet.</p>
      <p>
        Bei rechtlichen Streitigkeiten vereinbaren beide Parteien, dass diese je nach Streitwert vor dem&nbsp;
        <strong>Bezirksgericht Vilnius</strong> oder dem&nbsp;<strong>Regionalgericht Vilnius</strong> verhandelt
        werden.
      </p>

      <h2>
        <strong>7. Schlussbestimmungen</strong>
      </h2>
      <p>
        Imunodiagnostika behält sich das Recht vor, diese AGB jederzeit zu ändern.
        <br />
        &nbsp;Die aktuelle Version ist stets unter
        <a target="_blank" rel="noopener noreferrer" href="http://www.self.co/">
          &nbsp;
          <strong>
            <u>www.self.co</u>
          </strong>
        </a>{' '}
        verfügbar.
        <br />
        &nbsp;Geänderte AGB treten mit ihrer Veröffentlichung auf der Website in Kraft.
      </p>
      <p>
        Imunodiagnostika behält sich außerdem das Recht vor, Preise und Produktverfügbarkeit zu ändern, Aktionen zu
        starten oder zu beenden und diese jederzeit anzupassen.
      </p>
      <p>Imunodiagnostika haftet nicht für Handlungen Dritter, die dem Kunden Schaden zufügen.</p>
      <p>&nbsp;</p>

      <p>
        ✅&nbsp;<strong>Gültigkeit:</strong> Diese Allgemeinen Geschäftsbedingungen gelten ab dem Zeitpunkt ihrer
        Veröffentlichung auf
        <a target="_blank" rel="noopener noreferrer" href="http://www.self.co/">
          &nbsp;
          <strong>
            <u>www.self.co</u>
          </strong>
        </a>
        .
      </p>
    </div>
  );
}
